import { SVGProps } from 'react'

export const RocketSvg = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      version='1.1'
      viewBox='0 0 1024 1024'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path d='M608.8862214 708.91139385l325.06322965-325.06322964L924.19755417 100.05059485l-284.02089533-9.92559485-325.06322964 325.06322964zM647.05013308 379.77867062a103.84653598 103.84653598 0 1 1 146.84917512 0 103.84653598 103.84653598 0 0 1-146.84917512 0z' />
      <path d='M253.25215936 478.06687246l293.72316422 293.72316422 146.8491751-146.84917511L400.10133448 331.21769736z' />
      <path d='M339.87778833 608.34030445l73.42458673 73.42458754-146.84917429 146.84917512-73.42458754-73.42458756z' />
      <path d='M714.07271231 604.19636887v167.71773779l-156.551444 161.98570733v-173.69790901zM419.92771018 313.42606928l-156.12960608 156.55144399h-173.69790903l161.88645053-156.55144399h167.71773861z' />
    </svg>
  )
}
